export const RISK_UPPER_THRESHOLD = 1.1;
export const RISK_LOWER_THRESHOLD = 0.9;
